
import base from './mixin'

export default {
  mixins: [base],
  data () {
    return {
      chartName: 'line'
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vux/src/components/v-chart/v-line.vue